<template>
  <div class="p-grid">
    <div :class="isSidebarVisible?'p-col-fixed':'invisible'">
      <AppLeftMenu></AppLeftMenu>
    </div>
    <div :class="isSidebarVisible?'p-col':'p-col-12'">
      <div class="p-grid">
        <div class="p-col-12">
          <div class="p-grid">
            <div class="p-col-6">
              <Button class="p-button-secondary" icon="pi pi-angle-down"
                      v-on:click="toggleProductionSearch"></Button>
              <span class="caption">
                              {{ translate("filter.caption") }}
                            </span>
            </div>
            <div class="p-col-6" style="text-align: right">
              <Button :label="translate('button.search.reset')" v-on:click="reset"></Button>
              <Button :label="translate('button.search.save')" style="margin-left: 6px"
                      v-on:click="openSaveDialog"></Button>
            </div>
          </div>
        </div>
        <div v-if="productionSearchVisible" class="p-col-12 production-search">
          <div class="p-grid">
            <div v-if="hasProductionRows" class="p-col-12">
              <div class="p-grid p-fluid">
                <template v-for="(item) of getProductionSearchList">
                  <SearchRow v-bind:key="item.uniqueId"
                             :fieldList="productionSearchFields" :uniqueId="item.uniqueId"></SearchRow>
                </template>
              </div>
            </div>
            <div v-else>
              No Production Search
            </div>
            <div class="p-col-12">
              <Button :label="translate('button.add.condition')" v-on:click="addProductionSearch"></Button>
            </div>
          </div>
        </div>

        <div class="p-col-12">
          <Button class="p-button-secondary" icon="pi pi-angle-down" v-on:click="toggleAvailSearch"></Button>
          <span class="caption">
                     {{ translate("trafficLight.caption") }}
                </span>
        </div>
        <div v-if="availSearchVisible" class="p-col-12">
          <div class="p-grid">
            <template v-for="(item, index) of getTrafficLights">
              <SearchRowContainer v-bind:key="item.uniqueId" :conditions="item.conditions"
                                  :fieldList="licenceSearchFields"
                                  :index="index+1"
                                  :uniqueId="item.uniqueId"></SearchRowContainer>
            </template>
          </div>
        </div>
        <div class="p-col-12" style="text-align: right">
          <Button v-if="featureActive('externalOffers')" label="Create Offer" v-on:click="createOfferClick"
                  class="p-button-secondary p-mr-2"/>
          <Button :label="translate('button.add.trafficlight')" v-on:click="addTrafficLight"></Button>
          <Button :label="translate('button.search')" class="p-button-success" style="margin-left: 6px"
                  v-on:click="searchClick"></Button>
        </div>
        <div class="p-col-12">
          <MultiAvailGrid
              :colDefinitions="multiAvailColumns"
              :data-rows="multiAvailData"
              :loading="searching"
              v-on:selection="multiSelection"
              v-on:page="multiAvailPageEvent"
              v-on:sort="multiAvailSortEvent"
              v-on:filterChanged="filterUpdateEvent"
          />
        </div>
        <div class="p-col-12 bottom-grids">
          <TabView :style="{maxWidth: isSidebarVisible ? 'calc(100vw - 420px)':'100%'}">
            <TabPanel :active.sync="availDetailsActive" header="Availability Details">
              <AvailDetailsGrid
                  :dataRows="availDetails"
                  :loading="availDetailsLoading">
              </AvailDetailsGrid>
            </TabPanel>
            <TabPanel :active.sync="contractsActive" header="Contracts">
              <ContractGrid
                  :dataRows="contracts"
                  :loading="contractsLoading"
              >
              </ContractGrid>
            </TabPanel>
            <TabPanel
                v-if="featureActive('options')"
                :active.sync="optionsActive" header="Options">
              <OptionsGrid
                  :dataRows="options"
                  :loading="optionsLoading"
              >
              </OptionsGrid>
            </TabPanel>
            <TabPanel :active.sync="licenceHoldbacksActive"
                      :style="{maxWidth: isSidebarVisible ? 'calc(100vw - 420px)':'100%'}" header="Licences">
              <LicencesHoldbackGrid
                  :colDefinitions="licenceHoldbackCols"
                  :dataRows="licences"
                  :loading="licenceHoldbackLoading"
              >
              </LicencesHoldbackGrid>
            </TabPanel>
          </TabView>
        </div>
      </div>
      <Dialog :style="{width: '50vw', height: '50vw'}" :visible.sync="saveDialogVisible" class="my-dialog" modal>
        <template #header>
          Save search profile
        </template>

        <div class="p-grid">
          <div class="p-col-12">
            <RadioButton id="option1" v-model="saveMode" :disabled="!saveOverwriteActive" inputId="option1"
                         name="saveMode" value="overwrite"/>
            <label class="p-radiobutton-label" for="option1">Overwrite existing profile</label>
          </div>
          <div class="p-col-12">
            <RadioButton id="option2" v-model="saveMode" inputId="option2" name="saveMode" value="new"/>
            <label class="p-radiobutton-label" for="option2">Save as new Profile</label>
          </div>
          <div class="p-col-12">
            <InputText v-model="searchProfileName" :disabled="saveMode==='overwrite'"
                       placeholder="Search profile name"></InputText>
          </div>
        </div>
        <template #footer>
          <div class="p-grid p-justify-between">
            <div class="p-col-12">
              <Button :label="translate('button.cancel')" class="p-button-secondary" icon="pi pi-times"
                      v-on:click="cancelSaveClick"/>
              <Button :label="translate('button.save')" icon="pi pi-check" v-on:click="saveSearchClick"/>
            </div>
          </div>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import AppLeftMenu from "../layout/AppLeftMenu";
import SearchRow from "../components/SearchRow";
import SearchRowContainer from "../components/SearchRowContainer";
import {mapActions, mapGetters} from 'vuex';
import MultiAvailGrid from "../components/MultiAvailGrid";
import {getActiveColumnDefinitions} from "@/components/multiavailgridhelper";
import {getStaticColumns} from "@/components/licenceholdbackgridhelper";
import LicencesHoldbackGrid from "../components/LicencesHoldbackGrid";
import AvailDetailsGrid from "../components/AvailDetailsGrid";
import ContractGrid from "../components/ContractsGrid";
import OptionsGrid from "../components/OptionsGrid";
import TranslateService from "../services/translate.service";
import _ from 'lodash';

export default {
  name: 'Home',
  components: {
    ContractGrid,
    OptionsGrid,
    AvailDetailsGrid,
    LicencesHoldbackGrid,
    MultiAvailGrid,
    SearchRowContainer,
    SearchRow,
    AppLeftMenu
  },
  data() {
    return {
      productionSearchVisible: true,
      availSearchVisible: true,
      multiAvailCols: this.multiAvailColumns,
      multiAvailSelection: null,
      multiAvailPage: {sortField: '', first: 0, rows: 10, sortOrder: -1, page: 0},
      multiAvailSort: 'originalTitle_str',
      multiAvailFilters: {},


      licenceHoldbackCols: getStaticColumns(),
      licenceHoldbackLoading: false,
      licenceHoldbacksActive: false,
      availDetailsLoading: false,
      availDetailsActive: true,
      contractsLoading: false,
      contractsActive: false,
      optionsLoading: false,
      optionsActive: false,
      saveDialogVisible: false,
      searchProfileName: '',
      saveMode: 'overwrite',
      saveOverwriteActive: true,
      somethingHasChanged: true,

      throttledSearch: _.throttle(() => {
        this.searchClick()
      }, 1000)
    }
  },
  methods: {
    ...mapActions('search',
        ['addProductionSearch',
          'addTrafficLight',
          'addSearchProfile',
          'updateSearchProfile',
          'reset',
          'search',
          'loadLicences',
          'loadContractsStore',
          'loadOptionsStore',
          'loadAvailDetailsStore',
          'setMultiAvailFilters']),
    ...mapGetters('profiles',
        ['getActiveProfileFields']
    ),
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    openSaveDialog() {
      this.searchProfileName = this.getActiveProfileName;
      this.searchProfileName !== '' ? this.saveMode = 'overwrite' : this.saveMode = 'new';
      this.saveOverwriteActive = this.searchProfileName !== '';
      this.saveDialogVisible = true;
    },
    saveSearchClick() {
      if (this.searchProfileName !== '') {
        if (this.saveMode === 'new') {
          this.addSearchProfile(this.searchProfileName);
        } else {
          this.updateSearchProfile();
        }
      }
      this.saveDialogVisible = false;
    },
    cancelSaveClick() {
      this.saveDialogVisible = false;
    },
    multiAvailPageEvent(pageEvent) {
      console.log('PageEvent: ', pageEvent);

      this.multiAvailPage = pageEvent;
      this.searchClick();
    },
    multiAvailSortEvent(sortEvent) {
      console.log('SortEvent: ', sortEvent);

      this.multiAvailPage.sortField = sortEvent.sortField;
      this.multiAvailPage.sortOrder = sortEvent.sortOrder;

      this.multiAvailSort = sortEvent.sortOrder;
      this.multiAvailPage.page = 0;

      this.searchClick();
    },
    filterUpdateEvent(filters) {
      console.log('Filters: ', filters);

      this.multiAvailFilters = filters;
      this.setMultiAvailFilters(filters).then(() => {
        this.throttledSearch();
      })
      // _.throttle(this.searchClick, 250);
    },

    searchClick() {
      console.log("MultiavailPage: ", this.multiAvailPage);
      this.search(this.multiAvailPage);
    },
    createOfferClick() {
      const searchRequest = this.getAsSearchRequest;
      localStorage.setItem("searchRequest", JSON.stringify(searchRequest));
      location.href = "/offers/new";
    },
    toggleProductionSearch() {
      this.productionSearchVisible = !this.productionSearchVisible;
    },
    toggleAvailSearch() {
      this.availSearchVisible = !this.availSearchVisible;
    },
    loadLicenceHoldbacks() {
      if (this.licenceHoldbacksActive && this.multiAvailSelection != null && this.multiAvailSelection.length > 0) {
        this.licenceHoldbackLoading = true;
        this.loadLicences(this.multiAvailSelection[0].basemasterGUID).then(() => {
          this.licenceHoldbackLoading = false;
        }).catch(() => {
          this.licenceHoldbackLoading = false;
        });
      }
    },
    loadAvailDetails() {
      if (this.availDetailsActive && this.multiAvailSelection != null && this.multiAvailSelection.length > 0) {
        this.availDetailsLoading = true;
        this.loadAvailDetailsStore(this.multiAvailSelection[0].basemasterGUID).then(() => {
          this.availDetailsLoading = false;
        }).catch(() => {
          this.availDetailsLoading = false;
        });
      }
    },
    loadContracts() {
      if (this.contractsActive && this.multiAvailSelection != null && this.multiAvailSelection.length > 0) {
        this.contractsLoading = true;
        this.loadContractsStore(this.multiAvailSelection[0].basemasterGUID).then(() => {
          // this.contracts = r.data;
          this.contractsLoading = false;
        }).catch(() => {
          this.contractsLoading = false;
        })
      }
    },
    loadOptions() {
      if (this.optionsActive && this.multiAvailSelection != null && this.multiAvailSelection.length > 0) {
        this.optionsLoading = true;
        this.loadOptionsStore(this.multiAvailSelection[0].basemasterGUID).then(() => {
          // this.contracts = r.data;
          this.optionsLoading = false;
        }).catch(() => {
          this.optionsLoading = false;
        })
      }
    },
    multiSelection(val) {
      this.multiAvailSelection = val;
      this.loadLicenceHoldbacks();
      this.loadAvailDetails();
      this.loadContracts();
      this.loadOptions();
    },
  },
  computed: {
    ...mapGetters('config', [
      'productionSearchFields',
      'licenceSearchFields',
      'tableConfiguration']),
    ...mapGetters('search', [
      'getProductionSearchList',
      'hasProductionRows',
      'getTrafficLights',
      'getAll',
      'getAsSearchRequest',
      'getTrafficLightCount',
      'getActiveProfileName',
      'searching',
      'multiAvailData',
      'licences',
      'contracts',
      'options',
      'availDetails'
    ]),
    ...mapGetters('nav', [
      'isSidebarVisible'
    ]),
    ...mapGetters('config', [
      'featureActive'
    ]),
    multiAvailColumns() {
      let fields = this.getActiveProfileFields();
      // return getActiveColumnDefinitions(this.getTrafficLightCount ? this.getTrafficLightCount : 1,
      //     ['dynamicFields_originalTitle', 'dynamicFields_costUnitNumber', 'globalTrafficLight'],
      //     fields, this.tableConfiguration('MultiAvailGrid'));
      return getActiveColumnDefinitions(this.getTrafficLightCount ? this.getTrafficLightCount : 1,
          ['originalTitle', 'costUnitNumber', 'globalTrafficLight'],
          fields, this.tableConfiguration('MultiAvailGrid'));
    },
    sideBarClass() {
      return this.isSidebarVisible ? 'p-col-fixed' : 'p-col-fixed invisible';
    }
  },
  mounted() {

    this.reset();
  },
  watch: {
    licenceHoldbacksActive() {
      this.loadLicenceHoldbacks();
    },
    availDetailsActive() {
      this.loadAvailDetails();
    },
    contractsActive() {
      this.loadContracts();
    },
    optionsActive() {
      this.loadOptions();
    }
  }
}
</script>
<style>
.production-search {
  background-color: #f3f3f3;
}

.caption {
  font-size: 20px;
}

.p-button {
  margin-right: 5px;
}

.invisible {
  display: none;
}

.vertical-span {
  display: inline-block;
}

body .bottom-grids .p-tabview .p-tabview-panels {
  padding: 1px 0px 0px 0px;
  border: none;
}
</style>